// extracted by mini-css-extract-plugin
export const container = "contact-module--container--HevGw";
export const mainView1 = "contact-module--mainView1--3_-3u";
export const formBoxTop = "contact-module--formBoxTop--OXi4t";
export const formBox = "contact-module--formBox--3kZEM";
export const formHeading = "contact-module--formHeading--3MwLx";
export const name = "contact-module--name--1NgAA";
export const email = "contact-module--email--3JIEA";
export const message = "contact-module--message--3IiTV";
export const inputSubmit = "contact-module--inputSubmit--1t5Da";
export const submitButton = "contact-module--submitButton--1S8F5";
export const input1 = "contact-module--input1--b7QMm";
export const label1 = "contact-module--label1--2CBWQ";
export const textarea1 = "contact-module--textarea1--2l2Zh";
export const sMediaLink = "contact-module--sMediaLink--3jr01";
export const row1 = "contact-module--row1--CE-xe";
export const row2 = "contact-module--row2--17gYt";
export const row3 = "contact-module--row3--3ygDn";